module.exports = __webpack_public_path__ + "static/media/facebook-colored.aee03102.png";